export default "__VITE_ASSET__COjY9AmI__"